export default {"src":"/_next/static/media/logo.603d8cb3.svg","height":32,"width":126};